import { Component, OnInit } from '@angular/core';
import { CountryService } from '../../countries/country.service';
import { RegionService } from '../region.service';
import { Region } from '../region';
import { Message } from 'primeng/primeng';
import { NgForm } from '@angular/forms';


@Component({
  selector: 'app-region',
  templateUrl: './region.component.html',
  styleUrls: ['./region.component.css'],
  providers: [
              CountryService,
              RegionService
             ]
})
export class RegionComponent implements OnInit {

  id: null;  
  loading: boolean;
  loadingDialog: boolean;
  msgs: Message[] = [];
  display: boolean=false;
  region: Region;
  regions: string[];
  selectedCountry: string;
  button_caption: string ="Сохранить"
  button_icon:string ="fa fa-save";
  eventType: string;

  constructor(
              private countryService: CountryService,
              private regionService: RegionService
             ) { }

  ngOnInit() {

       this.init();

       this.loadRegions(); 

       this.countryService.getCountryList().subscribe(response=>{this.region.countries=response['data'].map(function(value: any){
               return {label:value.name, value: value.id};
       });});
  }

  loadRegions(){
    this.loading = true;
    this.regionService.getRegion().subscribe(response=> {this.regions=response['data']; ;this.loading = false;});
  }

  init(){
    this.region = {
      name: "",
      countries: [],
      available: true
    };
  }

  reset(){
    this.selectedCountry = this.region.countries[0];
    this.region.name = "";
  }  

  onAdd(){
    this.reset();
    this.eventType = "add";
    this.button_caption = "Сохранить";
    this.button_icon = "fa fa-save";
    this.display = true;
  }
  
  onEdit(id: any){
    this.reset();
    this.display = true;
    this.loadingDialog=true;
    this.id= id;
    this.eventType = "edit";
    this.button_caption = "Редактировать";
    this.button_icon = "fa fa-edit";
    this.regionService.getRegionById(id).subscribe(response=>{
      this.region = response['data'];
      this.countryService.getCountryList().subscribe(response=>{this.region.countries=response['data'].map(function(value: any){
        return {label:value.name, value: value.id};
      });
      this.loadingDialog=false;
      });
      this.selectedCountry=response['data'].country.id;
    });
  
 
  }

  crud(form: NgForm):void{
           if( this.eventType == "add"){
               this.loadingDialog=true;
               this.regionService.createRegion(form.value)
               .subscribe((data) => {this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно добавлено"});this.loadingDialog=false; this.display = false;this.loadRegions(); }
                    , (error)=>{
                                       let str="";
                                         this.loading=false; 
                                         for (let item in error.error.errors) {
                                               str+="\n" +error.error.errors[item][0];
                                         }
                                         this.msgs=[];this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: "+str});
                                 });
  
           }else{
             this.loadingDialog=true;
             this.regionService.updateRegion(form.value,this.id)
               .subscribe((data) => {this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно изменено"});this.loadingDialog=false; this.display = false;this.loadRegions(); }
                    , (error)=>{
                                    let str="";
                                         this.loading=false; 
                                         for (let item in error.error.errors) {
                                               str+="\n" +error.error.errors[item][0];
                                         }
                                         this.msgs=[];this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: "+str});
                                 });
           }
    }

}




// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/regions/region/region.component.ts